import React, { Component } from 'react'
import { Row, Icon } from 'antd'
import { inject, observer } from 'mobx-react'
import { hmoCost } from '@services/api'

@inject((store: any) => {
    const { authStore } = store
    return { authStore }
})
@observer
export default class extends Component {
    constructor(props) {
        super(props)
        this.state = { ...props.policy }
    }

    handleUpdate = (key, value) => this.setState({ [key]: +value })

    render() {
        const { age_to, age_from, price, updated_by, updated_at } = this.state
        const {
            authStore: { fullName },
            update,
            updatePolicy
        } = this.props
        let marginRight = { marginRight: 20 }
        let inputStyle = { marginRight: 8, width: 80 }

        return (
            <Row gutter={28}>
                <span style={marginRight}>גיל מינימלי: {age_from}</span>
                <span style={marginRight}>גיל מקסימלי: {age_to}</span>
                <span style={marginRight}>
                    מחיר:
                    <input
                        type="number"
                        style={inputStyle}
                        value={price}
                        onChange={e => this.setState({ price: e.target.value })}
                    />
                </span>
                <Icon
                    style={marginRight}
                    type="check"
                    onClick={async () => {
                        await updatePolicy({ ...this.state, updated_by: fullName })
                        update()
                    }}
                />
                {updated_by && (
                    <span style={marginRight}>
                        {updated_by} - {updated_at}
                    </span>
                )}
            </Row>
        )
    }
}
